import _get from 'lodash/get';
import _find from 'lodash/find';
import _keys from 'lodash/keys';
import queryString from 'query-string';

declare global {
  interface Window {
    google_tag_manager: any,
  }
}

interface Options {
  onChange: (data: {
    measurement_id?: string,
    client_id?: string,
    gclid?: string,
  }) => void;
}

export function collectParams({ onChange }: Options): Promise<void> {
  return new Promise((resolve) => {
    const f = () => {
      const measurement_id = _find(_keys(window.google_tag_manager), k => k.indexOf('G-') === 0) || undefined;
      const client_id = _get(window, 'gaGlobal.vid') || undefined;
      const gclid = String(queryString.parse(window.location.search).gclid || '') || undefined;

      if (measurement_id && client_id) {
        onChange({
          measurement_id,
          client_id,
          gclid,
        });
        resolve();
      } else {
        setTimeout(f, 50);
      }
    };
    f();
  });
}
